import $ from 'jquery';

const configuration = () => {
    $('.configuration .map .button').on('click', function(){
        var _this = $(this);
        var number_id = _this.attr('data-button');
        var left_value = _this.attr('data-left');
        var top_value = _this.attr('data-top');
        var rayon_value = _this.attr('data-rayon');

        var height_underline = $('.configuration .line').attr('data-height');
        var width_underline = $('.configuration .line').attr('data-width');

        if(!height_underline && !width_underline){
            height_underline = $('.configuration .line').height();
            width_underline = $('.configuration .line').width();

            $('.configuration .line').attr('data-height', height_underline);
            $('.configuration .line').attr('data-width', width_underline);
        }

        if(parseInt(height_underline) > parseInt(top_value)){
            height_underline = height_underline - top_value;
            $('.configuration .line').css('transform','none');
            var top_line = parseInt(top_value) + parseInt(rayon_value);
        }
        else{
            var top_line = parseInt(height_underline) + parseInt(rayon_value);
            height_underline = top_value - height_underline;
            $('.configuration .line').css('transform','rotatex(180deg)');
        }
        width_underline = width_underline - left_value;


        if($('.map').hasClass('vertical')){
            width_underline = ($('.map').width() / 2) - left_value;
            height_underline = parseInt(top_value) + 155;

            top_line = '-155';
            console.log(top_line);
            console.log(top_line);

            if(left_value > ($('.map').width() / 2)){
                width_underline = left_value - ($('.map').width() / 2);
                $('.configuration .line').css('transform','none');
                left_value = left_value - width_underline;
            }else{
                $('.configuration .line').css('transform','rotatex(180deg)');
            }
        }


        $('.configuration .line').height(height_underline);
        $('.configuration .line').width(width_underline);

        $('.configuration .line').css('left', left_value +'px');
        $('.configuration .line').css('top', top_line+'px');

        $('.configuration .line').show();

        $('.configuration .map .picture').each(function(){
            $(this).hide();
        });

        if($('#map-picture-'+number_id).length > 0)
            $('#map-picture-'+number_id).show();
        else
            $('.configuration .line').hide();

        $('.configuration .map .button').each(function(){
            $(this).removeClass('active');
        })

        _this.addClass('active');

        $('.configuration .labels .label').each(function(){
            $(this).removeClass('active');
        });

        $('#label-'+number_id).addClass('active');
    });

    $('.configuration .map .button').on('mouseover', function(){
        var number_id = $(this).attr('data-button');
        $('#label-'+number_id).addClass('active');
        $(this).trigger('click');
    });

    $('.configuration .map .button').on('mouseout', function(){
        var number_id = $(this).attr('data-button');
        $('#label-'+number_id).removeClass('active');
    });

    $('.configuration .labels .label').on('click', function(){
        var _this = $(this);
        var number_id = _this.attr('data-number');

        $('.configuration .labels .label').each(function(){
            $(this).removeClass('active');
        })

        _this.addClass('active');

        $('#button-'+number_id).trigger('click');
    });

    $('.configuration .labels .label').on('mouseover', function(){
        var number_id = $(this).attr('data-number');
        $('#button-'+number_id).trigger('click');
    });
}

export default configuration;
